/**
 * Copyright © 2023, Lumenore Inc. All rights reserved.
 * This software is the confidential and proprietary information of
 * Lumenore Inc. "Confidential Information".
 * You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the intellectual property agreement
 * you entered into with Lumenore Inc.
 * THIS SOFTWARE IS INTENDED STRICTLY FOR USE BY Lumenore Inc.
 * AND ITS PARENT AND/OR SUBSIDIARY COMPANIES. Lumenore
 * MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
 * Lumenore SHALL NOT BE LIABLE FOR ANY DAMAGES SUFFERED BY ANY PARTY AS A RESULT
 * OF USING, MODIFYING OR DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 */

type Variables = {
    [key: string]: boolean | string | number
};
type NestedObject<T> = {
    [key: string]: T | NestedObject<T>;
};

type LocalizationData = NestedObject<string>;
const replaceVariablesWithValue = (value: string = '', variables: Variables = {}): string => {
    let updatedValue = value;
    Object.entries(variables).forEach(([key, val]) => {
        if (typeof updatedValue.replaceAll === 'function') {
            const dollarWithOpeningBraces = '${';
            const closingBraces = '}';
            if (typeof val !== "boolean") {
                updatedValue = updatedValue.replaceAll(`${dollarWithOpeningBraces}${key}${closingBraces}`, String(val));
                const withOpeningBraces = '{';
                updatedValue = updatedValue.replaceAll(`${withOpeningBraces}${key}${closingBraces}`, String(val));
            }
        }
        // else: do nothing
    });
    return updatedValue;
};

function getLocalizationValue(localizationData: LocalizationData, key: string): string | null {
    const keysToFind = key.split('.');
    let current: string | LocalizationData = localizationData;
    let localizationValue: string | null = null
    for (const k of keysToFind) {
        if (typeof current === 'object' && current?.[k]) {
            current = current[k];
            if (typeof current === 'string') {
                localizationValue = current
            }
        }
        else {
            return null;
        }
    }

    return localizationValue;
}

export const getTranslateToLocale = (localizationData: LocalizationData = {}, key: string = '', fallback: string = '', variables: Variables = {}): string => {
    const data = getLocalizationValue(localizationData, key);
    if (data) {
        return replaceVariablesWithValue(data, variables);
    } else {
        return replaceVariablesWithValue(fallback || key, variables);
    }
};

const translateToLocale = (key: string = '', fallback: string = '', variables: (Variables | undefined) = {}) => getTranslateToLocale({}, key, fallback, variables)

export default translateToLocale
